import React, { FC, ReactNode } from 'react'
import { Box, makeStyles, Typography } from 'transfix-ui/core'
import { getHaulTypeString } from 'apps/fleet-planner/utils/bookableShipmentSavedSearch'
import { Radio } from 'transfix-ui'
import { HAUL_TYPE_MILES } from 'constants/equipment'

export const useHaulTypeFilterStyles = makeStyles(theme => ({
  radioLabelOne: {
    fontSize: 14,
    fontWeight: theme.typography.fontWeightBold,
  },
  radioLabelTwo: {
    fontSize: 14,
    fontWeight: theme.typography.fontWeightRegular,
  },
}))

interface IHaulTypeFilterLabelProps {
  labelOne: string
  labelTwo: string
}

const HaulLengthFilterLabel: FC<IHaulTypeFilterLabelProps> = ({ labelOne, labelTwo }) => {
  const classes = useHaulTypeFilterStyles()
  return (
    <>
      <Typography display='inline' className={classes.radioLabelOne}>
        {labelOne}
      </Typography>{' '}
      <Typography className={classes.radioLabelTwo} display='inline'>
        {labelTwo}
      </Typography>
    </>
  )
}

type THaulType = 'local' | 'short' | 'long'

export interface ILoadedMiles {
  loadedMilesMin?: number | null
  loadedMilesMax?: number | null
}

interface IHaulLengthFilter {
  label: ReactNode
  value: ILoadedMiles
  filterName: string
  dataTest: string
}

const HAUL_LENGTH_FILTER: Partial<Record<THaulType, IHaulLengthFilter>> = {
  local: {
    label: <HaulLengthFilterLabel labelOne='Local Hauls' labelTwo='up to 100 mi' />,
    value: { loadedMilesMin: HAUL_TYPE_MILES.local.min, loadedMilesMax: HAUL_TYPE_MILES.local.max },
    filterName: 'local',
    dataTest: 'local-haul-radio-input',
  },
  short: {
    label: <HaulLengthFilterLabel labelOne='Short Hauls' labelTwo='100 mi - 300 mi' />,
    value: { loadedMilesMin: HAUL_TYPE_MILES.short.min, loadedMilesMax: HAUL_TYPE_MILES.short.max },
    filterName: 'short',
    dataTest: 'short-haul-radio-input',
  },
  long: {
    label: <HaulLengthFilterLabel labelOne='Long Hauls' labelTwo='over 300 mi' />,
    filterName: 'long',
    value: { loadedMilesMin: HAUL_TYPE_MILES.long.min, loadedMilesMax: HAUL_TYPE_MILES.long.max },
    dataTest: 'long-haul-radio-input',
  },
}

interface IHaulTypeFilterProps {
  loadedMilesMax?: ILoadedMiles['loadedMilesMax']
  onChange: (loadedMiles?: ILoadedMiles) => void
}

export const HaulTypeFilters: FC<IHaulTypeFilterProps> = ({ loadedMilesMax, onChange }) => {
  const keys = Object.keys(HAUL_LENGTH_FILTER) as THaulType[]

  return (
    <Box>
      {keys.map(key => {
        const haulLength = HAUL_LENGTH_FILTER[key]
        const { dataTest, filterName, label, value } = haulLength || {}
        const haulTypeChangeHandler = () => onChange(value)
        const isSelected = getHaulTypeString(loadedMilesMax) === filterName
        return (
          <Box mb={1} key={key}>
            <Radio
              dataTest={dataTest}
              value={key}
              checked={isSelected}
              onChange={haulTypeChangeHandler}
              label={label}
            />
          </Box>
        )
      })}
    </Box>
  )
}
